import React from "react";
import consoleFrame1 from "../../images/consoleFrame1.svg";
import consoleFrame2 from "../../images/consoleFrame2.svg";

export interface IVideoPlayer {
  videoURL: string;
  displayNextSlide: () => void;
  styles?: Object;
  isAnimation?: boolean | false;
}

const VideoPlayer = (props: IVideoPlayer) => {
  const videoRef = React.useRef<HTMLVideoElement>(null);
  const [isAnimation, setAnimation] = React.useState(false);
  let styleSheet = document.styleSheets[0];
  let animationName = "minimize-animation";
  let flickAnimation = `@-webkit-keyframes ${animationName} {
    0%   {left:20%; top:8rem; width: 50%; height: 55%;}
    100%  {left:5%; top: 15%; width: 40%; height: 20%;}
  }`;
  //50%  {left:15%; top:6rem; width: 45%; height: 48%;}
  // 75%  {left:10%; top:4rem; width: 40%; height: 30%;}
  styleSheet.insertRule(flickAnimation, styleSheet.cssRules.length);

  const style2 = {
    height: "30%",
    marginTop: "8rem",
    ...props?.styles,
    ...(isAnimation && {
      animationName: animationName,
      animationTimingFunction: "linear",
      animationDuration: "0.8s",
      animationIterationCount: 1,
    }),
  };

  return (
    <div
      style={style2}
      onAnimationEnd={() => {
        props.displayNextSlide();
      }}
    >
      <div
        style={{ display: "flex", flexDirection: "column", width: "inherit" }}
      >
        <img
          src={consoleFrame1}
          alt="consoleFrame1"
          style={{ width: "100%", objectFit: "contain" }}
        />
        <img
          src={consoleFrame2}
          alt="consoleFrame1"
          style={{ width: "100%", objectFit: "contain" }}
        />

        <video
          src={props.videoURL}
          ref={videoRef}
          onEnded={() => {
            props.displayNextSlide();
          }}
          onTimeUpdate={(event) => {
            if (event.currentTarget.currentTime > 4 && props?.isAnimation) {
              setAnimation(true);
            }
          }}
          autoPlay
        />
      </div>
    </div>
  );
};

export default VideoPlayer;
